import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const ProtectedRoute = ({ children, requireRole }) => {
  const { authenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #faf5ff 0%, #fce7f3 50%, #dbeafe 100%)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '3rem', 
            marginBottom: '1rem',
            animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
          }}>
            📚
          </div>
          <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required role
  if (requireRole && user && user.role !== requireRole) {
    // Redirect to appropriate dashboard based on user role
    if (user.role === 'parent') {
      return <Navigate to="/parent-dashboard" replace />;
    } else {
      return <Navigate to="/grandparent-dashboard" replace />;
    }
  }

  return children;
};